import React from 'react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
    this.reset = this.reset.bind(this);
  }

  static getDerivedStateFromError(/* error */) {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Minimal privacy-safe logging placeholder — callers may integrate real logging.
    // Do not include invoice/user data here.
    // eslint-disable-next-line no-console
    console.warn('ErrorBoundary caught error', { name: error?.name, stack: info?.componentStack });
  }

  reset() {
    this.setState({ hasError: false });
  }

  render() {
    const { hasError } = this.state;
    const { children, title = 'Something went wrong', description = null } = this.props;

    if (!hasError) return children;

    return (
      <div
        className="rounded-sm border border-rose-200 bg-rose-50 p-4 text-rose-700"
        role="alert"
        aria-live="assertive"
      >
        <div className="flex items-start gap-3">
          <div className="flex-1">
            <div className="font-semibold text-rose-800">{title}</div>
            <div className="text-sm text-rose-600 mt-1">
              {description || 'This panel could not be loaded. Try again or refresh the page.'}
            </div>
          </div>
          <div className="flex items-start">
            <button
              type="button"
              onClick={this.reset}
              aria-label="Retry panel"
              className="text-[12px] font-semibold text-rose-700 hover:text-rose-900 focus:outline-none focus:ring-2 focus:ring-offset-1 focus:ring-rose-300 rounded"
            >
              Retry
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
